import React, { memo } from 'react'
import { ArrowRightIcon } from '../../assets/icons/ArrowRightIcon'
import { BUTTON_STYLE_DEFAULT_PRIMARY } from '../../libraries/ButtonTheme'
import Button from '../button/Button'
import './BannerAssembleia.scss'
const rootClassName = 'banner-assembleia'

interface BannerAssembleiaProps {
  imgUrl: string
  breadCrumb: string
  buttonLabel: string
  onButtonClick: (evt: any) => void
  text: string
}

function BannerAssembleia(props: BannerAssembleiaProps) {
  return (
    <div className={rootClassName}>
      <div className={`${rootClassName}-left`}>
        <div className={`${rootClassName}-bread-crumb`}>{props.breadCrumb}</div>
        <div className={`${rootClassName}-text`}>{props.text}</div>
        <div className={`${rootClassName}-button`}>
          <Button
            onClick={props.onButtonClick}
            theme={BUTTON_STYLE_DEFAULT_PRIMARY}
            rightIcon={<ArrowRightIcon />}
          >
            {props.buttonLabel}
          </Button>
        </div>
      </div>
      <div
        className={`${rootClassName}-imagem`}
        style={{ backgroundImage: `url(${props.imgUrl})` }}
      >
        <img alt='img' src={props.imgUrl} />
      </div>
    </div>
  )
}

export default memo(BannerAssembleia)
